import React from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import EditorialMarquee from "../components/site/EditorialMarquee";
import Manifesto from "../components/site/Manifesto";
import Services from "../components/site/Services";
import Works from "../components/site/Works";
import Process from "../components/site/Process";
import Testimonials from "../components/site/Testimonials";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import useSeo from "../hooks/useSeo";

export default function Home() {
    useSeo({
        title:
            "GreenDuck — Estúdio de Tecnologia · Apps, Sites, IA e Automação",
        description:
            "Desenvolvimento de apps mobile, sites de alta conversão, integrações com IA e automação de processos para empresas que querem crescer. Fale com o estúdio.",
        canonical: "https://www.greenduck.com.br/",
    });
    return (
        <div className="App" data-testid="home-page">
            <Navbar />
            <Hero />
            <EditorialMarquee />
            <Manifesto />
            <Services />
            <Works />
            <Process />
            <Testimonials />
            <Contact />
            <Footer />
        </div>
    );
}
